import { apiClient } from "../lib/api";

export const systemJobsApi = {
  list: () => apiClient.get("/system/jobs"),
  failureCount: () => apiClient.get("/system/jobs/failure-count"),
  runHistory: (jobName) => apiClient.get(`/system/jobs/${jobName}/runs`),
  runNow: (jobName) => apiClient.post(`/system/jobs/${jobName}/run`),
};
